import DynamicPage from '@/components/DynamicPage/DynamicPage';
import PAGE_IDS from '@/consts/pageIds';

const BadgesPage = () => <DynamicPage pageId={PAGE_IDS.BADGES} className='pt-app-4 pb-app-menu' />;

export default BadgesPage;
